/* import $ from "jquery"; */

// Sticky header
document.addEventListener("DOMContentLoaded", function(){
	window.addEventListener('scroll', function() {

		if (document.querySelector('body')) {

			const body = document.querySelector('body');

			if (window.scrollY > 50) {
		  	body.classList.add('fixed');		  
			} else {
		 	 body.classList.remove('fixed');
			}
		}
		
	});
}); 

// back-to-top
(function() {

	let back_to_top_button = document.createElement("a");
	back_to_top_button.className = "back_to_top";
	back_to_top_button.title = "Zurück nach oben";
	back_to_top_button.innerHTML = "&uarr;";
	document.querySelector("body").append(back_to_top_button);
  
	function trackScroll() {
	  var scrolled = window.scrollY;
	  var coords = document.documentElement.clientHeight;
  
	  if (scrolled > coords) {
		goTopBtn.classList.add('back_to_top-show');
	  }
	  if (scrolled < coords) {
		goTopBtn.classList.remove('back_to_top-show');
	  }
	}
  
	function backToTop() {
		window.scrollTo(0,0);
	}
  
	var goTopBtn = document.querySelector('.back_to_top');
  
	window.addEventListener('scroll', trackScroll);
	goTopBtn.addEventListener('click', backToTop);
  })();




// call button toggle
if (document.getElementById("call-button")){
	var callBtn = document.getElementById("call-button"),
		callPop = document.getElementById("call-popup");

		callBtn.onclick = togglePopClass;

	function togglePopClass() {
		if ( -1 !== callPop.className.indexOf( "open" ) ) {
			callPop.className = callPop.className.replace( " open", "" );
		} 
		else {
			callPop.className += " open";
		}
	}
}



// search overlay
if (document.getElementById("search-button")){
	var searchBtn = document.getElementById("search-button"),
		searchOvrl = document.getElementById("search-overlay"),
		closehOvrl = document.getElementById("close-search-overlay");

		searchBtn.onclick = toggleOvrlClass;
		closehOvrl.onclick = toggleOvrlClass;

	function toggleOvrlClass() {
		if ( -1 !== searchOvrl.className.indexOf( "open" ) ) {
			searchOvrl.className = searchOvrl.className.replace( " open", "" );
			document.body.style.overflow="";
		} 
		else {
			searchOvrl.className += " open";
			document.body.style.overflow="hidden";
		}
	}
}




// mobile menu
if (document.getElementById("menu-btn")){
	var menuOpen = document.getElementById("menu-btn"),
		mainnavArea = document.getElementById("mainnav-area"),
		menuClose = document.getElementById("menu-btn-close"),
		menuOverlay = document.getElementById("menu-overlay");

		menuOpen.onclick = toggleMenuClass;
		menuClose.onclick = toggleMenuClass;

	function toggleMenuClass() {
		if ( -1 !== mainnavArea.className.indexOf( "is-active" ) ) {
			mainnavArea.className = mainnavArea.className.replace( " is-active", "" );
			document.body.style.overflow="";
		} 
		else {
			mainnavArea.className += " is-active";
			document.body.style.overflow="hidden";
		}
		if ( -1 !== menuOverlay.className.indexOf( "is-active" ) ) {
			menuOverlay.className = menuOverlay.className.replace( " is-active", "" );
		} 
		else {
			menuOverlay.className += " is-active";
		}
	}

	let menuLinkLevel1 = document.querySelectorAll(".menu-link-level-1");

	for(let i = 0; i < menuLinkLevel1.length; i++){
		menuLinkLevel1[i].addEventListener("click",function(event){
			menuLinkLevel1[i].className += " is-active";
		})
	}

	let menuBackButton = document.querySelectorAll(".menu-backbtn");

	for(let i = 0; i < menuBackButton.length; i++){
		menuBackButton[i].addEventListener("click",function(event){
			let parent = menuBackButton[i].parentElement.parentElement.previousElementSibling;
			parent.className = parent.className.replace(" is-active", "");
		})
	}

}

// move mainnav out of header into body on mobile
if(document.querySelector('#mainnav-area') != null){
	function moveMainNav (){
		var a = document.querySelector('header');
		var b = document.querySelector('body');
		var c = document.querySelector('#mainnav-area');
		if (1200 >= window.innerWidth && 'a' === c.dataset.location) {
				b.appendChild(c);
				c.dataset.location = 'b';
			} else if (1200 < window.innerWidth && 'b' === c.dataset.location) {
				a.appendChild(c);
				c.dataset.location = 'a';
			}
	}
	window.addEventListener('load', function () {   
		moveMainNav();
		window.addEventListener('resize', function (event) {
			moveMainNav();
		});
	}, {once: true});
}
